export enum SortTypes {
  HighestRating = 'highest_rating',
  LowestRating = 'lowest_rating',
  Created = 'created',
}

export type Review = {
  _id: string;
  author: string;
  created: string;
  date: string;
  img: string[];
  original_text: string;
  partner_id: string;
  rating: number;
  rating_max: number;
  text: string;
  ts: string;
  type: string;
  url: string;
};

export type ReviewSummary = {
  average_rating: number;
  reviews?: Review[];
  total: number;
};
